import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  regular: {
    fontWeight: "normal",
  },
  tableContainer: {
    padding: theme.spacing(2),
    width: "auto !important",
    overflowX: "auto !important",
    "& td.disabled, & td.disabled a": {
      color: "#B3BAC5 !important",
    },
    flex: "1",
  },
  table: {
    minWidth: 650,
    tableLayout: "fixed",
  },
  tableLink: {
    color: "#030F85",
    fontWeight: "bold",
    textDecoration: "none",
  },
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  largeEllipsis: {
    maxWidth: "100%",
  },
  normalEllipsis: {
    maxWidth: "100%",
  },
  tableFooter: {
    position: "sticky",
    left: 0,
    bottom: 0,
    backgroundColor: "white",
    "& td": {
      border: "none !important",
      paddingBottom: 7,
      paddingTop: 20,
      paddingLeft: 0,
    },
    "& tr": {
      border: "none",
    },
  },
  tableCell: {
    "&.MuiTableCell-root": {
      fontFamily: theme.font.workSans,
      wordBreak: "break-word",
    },
    "& .MuiOutlinedInput-root": {
      border: "1px solid #0000003b",
    },
    "& .MuiInputBase-root.Mui-focused": {
      border: "2px groove #3f51b5",
      borderTop: "1px solid #3f51b5",
      borderLeft: "1px solid #3f51b5",
    },
    "& fieldset": {
      border: "none",
    },
  },
  tableTitle: {
    textTransform: "uppercase",
    background: "#F4F5F7 0% 0% no-repeat padding-box",
    borderRadius: "3px 3px 0px 0px",
    "& tr": {
      verticalAlign: "bottom",
    },
    "& th": {
      color: "#7A869A",
      lineHeight: "16px",
      fontSize: 13,
      fontFamily: "Work Sans, sans-serif",
    },
    "& th, td": {
      lineHeight: "16px",
    },
    "& .MuiInputLabel-shrink": {
      background: `${theme.color.gray1} !important`,
    },
  },
  tableCellSimple: {
    padding: "2px 12px !important",
  },
  tableCellIn: {
    padding: "7px 12px",
    minHeight: 40,
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    overflow: "hidden",
    "& > span[class*='base']": {
      textAlign: "center",
      padding: "2px 5px",
      width: "100%",
      minHeight: 35,
    },
  },
  CircularProgress: {
    display: "flex",
    justifyContent: "center",
    marginTop: 10,
  },
  BodyMissingTextContainer: {
    textAlign: "center",
    padding: "15px",
  },
  TableRow: {
    cursor: "pointer",
    "&.nopointer": {
      cursor: "default !important",
    },
  },
  relative: {
    position: "relative",
  },
  paginationFooter: {
    display: "flex",
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
    textAlign: "right",
    "& button": {
      fontSize: 14,
      fontWeight: "bold",
      minWidth: 24,
      padding: 0,
      margin: "0 4px",
      "&-page": {
        padding: 0,
      },
      "&.active": {
        color: "#457DD9",
        background: "#457DD926 0% 0% no-repeat padding-box",
      },
      "&:hover": {
        color: "#457DD9",
        background: "#457DD926 0% 0% no-repeat padding-box",
      },
    },
  },
  jLoadingTable: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  jNoResultPlaceHolder: {
    backgroundColor: "rgba(255,255,255,0.9)",
    position: "absolute",
    top: 0,
    left: 0,
    minHeight: "420px",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& h3": {
      position: "relative",
      // top: '-130px',
    },
  },
}));
